module.exports = __webpack_public_path__ + "static/media/blackfridaybanner.b140cb40.jpeg";